export default "__VITE_ASSET__CBuY$sWr__"